import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  setDisplayName,
  setPropTypes,
  defaultProps,
} from 'recompose';
import classNames from 'classnames';
import { connect } from 'react-redux';
import rpCookie from 'rp-cookie';
import PaymentTitle from './PaymentTitle';
import PaymentList from './PaymentList';
import PaymentButton from './PaymentButton';
import { addCardSuccess } from '../../../../actions/payment';
import parseCreditCard from '../../helpers/parseCreditCard';
import styles from './PaymentDetails.scss';

const ADD_CARD_SUCCESS = 'addCardSuccess';
export class PaymentDetails extends Component {
    state = {
      session: rpCookie.sharedPermanent.get('rp_guid') || null,
      isPaymentFrameVisible: false,
    };

    onMessageHandler = ({ data }) => {
      if (data === ADD_CARD_SUCCESS) {
        this.paymentWindow.close();
        this.props.addCardSuccess();
        window.removeEventListener('message', this.onMessageHandler);
      }
    };

    handleCardAdd = () => {
      this.paymentWindow = window.open(`${global.__PRELOADED_STATE__.config.paymentPageUrl}/?action=addCard&returnUrl=${encodeURIComponent(`//${global.location.host}/subscriptions/my-account/`)}&guid=${this.state.session}`);
      window.addEventListener('message', this.onMessageHandler);
    };

    render() {
      const { session, isPaymentFrameVisible } = this.state;
      const { vip, card, expired } = this.props;
      const isIframeVisible = session && isPaymentFrameVisible;
      const isIframeDisabled = expired || vip || isIframeVisible;

      return (
        <div className={classNames(styles.root, { [styles.vip]: vip })}>
          <PaymentTitle>Subscription Payment Details</PaymentTitle>
          <div className={styles.details}>
            <PaymentList card={parseCreditCard(card)} vip={vip} />
            <PaymentButton
              onClick={this.handleCardAdd}
              disabled={isIframeDisabled}>
                      Add a new card
            </PaymentButton>
          </div>
        </div>
      );
    }
}

export default compose(
  setDisplayName('PaymentDetails'),
  defaultProps({
    vip: false,
  }),
  connect(null, { addCardSuccess }),
  setPropTypes({
    addCardSuccess: PropTypes.func.isRequired,
    card: PropTypes.shape({
      CardName: PropTypes.string,
      CreditCardType: PropTypes.string,
      DateValidated: PropTypes.string,
      ExpiryDate: PropTypes.string,
      IsValidated: PropTypes.boolean,
      LastFourDigits: PropTypes.string,
    }).isRequired,
    expired: PropTypes.bool.isRequired,
    vip: PropTypes.bool.isRequired,
  }),
)(PaymentDetails);
